module.exports = __webpack_public_path__ + "static/media/mlogo.f4ac57e1.png";